import React, { useRef, useLayoutEffect, useState } from "react";

// AutoFitText: fits text to container by adjusting font size between min and max
export default function AutoFitText({ text = '', min = 10, max = 18, className = '', ...props }) {
  const containerRef = useRef(null);
  const textRef = useRef(null);
  const [fontSize, setFontSize] = useState(max);

  useLayoutEffect(() => {
    const container = containerRef.current;
    const textNode = textRef.current;
    if (!container || !textNode) return;

    let frameId = null;
    const fitsAtSize = (size) => {
      textNode.style.fontSize = `${size}px`;
      const fitsWidth = textNode.scrollWidth <= container.clientWidth + 1;
      const fitsHeight = textNode.scrollHeight <= container.clientHeight + 1;
      return fitsWidth && fitsHeight;
    };

    const measure = () => {
      if (!container.clientWidth || !container.clientHeight || !text) {
        setFontSize(max);
        return;
      }
      let low = min;
      let high = max;
      let best = min;
      for (let step = 0; step < 8; step += 1) {
        const mid = Number(((low + high) / 2).toFixed(2));
        if (fitsAtSize(mid)) {
          best = mid;
          low = mid;
        } else {
          high = mid;
        }
        if (Math.abs(high - low) < 0.35) break;
      }
      if (fitsAtSize(max)) best = max;
      textNode.style.fontSize = `${best}px`;
      setFontSize((current) => (Math.abs(current - best) < 0.25 ? current : best));
    };
    function scheduleMeasure() {
      if (frameId) cancelAnimationFrame(frameId);
      frameId = requestAnimationFrame(measure);
    }
    scheduleMeasure();
    return () => {
      if (frameId) cancelAnimationFrame(frameId);
    };
  }, [max, min, text]);

  return (
    <div
      ref={containerRef}
      className={className}
      style={{ width: '100%', minWidth: 0, flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', overflow: 'hidden' }}
      {...props}
    >
      <div
        ref={textRef}
        style={{ width: '100%', fontSize: `${fontSize}px`, lineHeight: '1.15', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', textAlign: 'center' }}
      >
        {text}
      </div>
    </div>
  );
}
